const State = {
  combinedBillList: [],
  maxSortNumber: 0
}

export default State
